import React from "react";
import classnames from "classnames";
import { usePagination, DOTS } from "./usePagination";
import "./pagination.scss";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 0,
    currentPage,
    pageSize,
    className,
    ariaLabel = "Pagination"
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];

  return (
    <nav aria-label={ariaLabel}>
      <ul
        className={classnames("pagination-container", { [className]: className })}
      >
        <li
          className={classnames("pagination-item", {
            disabled: currentPage === 1
          })}
        >
          <button
            type="button"
            className="pagination-button"
            onClick={onPrevious}
            disabled={currentPage === 1}
            aria-label="Previous page"
          >
            <span className="arrow left" aria-hidden="true" />
          </button>
        </li>
        {paginationRange.map((pageNumber, index) => {
          if (pageNumber === DOTS) {
            return (
              <li key={`dots-${index}`} className="pagination-item dots">
                <span aria-hidden="true">&#8230;</span>
              </li>
            );
          }

          return (
            <li
              key={pageNumber}
              className={classnames("pagination-item", {
                selected: pageNumber === currentPage
              })}
            >
              <button
                type="button"
                className="pagination-button"
                onClick={() => onPageChange(pageNumber)}
                aria-label={`Page ${pageNumber}`}
                aria-current={pageNumber === currentPage ? "page" : undefined}
              >
                {pageNumber}
              </button>
            </li>
          );
        })}
        <li
          className={classnames("pagination-item", {
            disabled: currentPage === lastPage
          })}
        >
          <button
            type="button"
            className="pagination-button"
            onClick={onNext}
            disabled={currentPage === lastPage}
            aria-label="Next page"
          >
            <span className="arrow right" aria-hidden="true" />
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
